/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsColorCollection,
    MelcoModelsColorCollectionFromJSON,
    MelcoModelsColorCollectionFromJSONTyped,
    MelcoModelsColorCollectionToJSON,
    MelcoModelsDesignElementColor,
    MelcoModelsDesignElementColorFromJSON,
    MelcoModelsDesignElementColorFromJSONTyped,
    MelcoModelsDesignElementColorToJSON,
    MelcoModelsDesignLetteringElement,
    MelcoModelsDesignLetteringElementFromJSON,
    MelcoModelsDesignLetteringElementFromJSONTyped,
    MelcoModelsDesignLetteringElementToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsDesignElement
 */
export interface MelcoModelsDesignElement {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDesignElement
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDesignElement
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDesignElement
     */
    type?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MelcoModelsDesignElement
     */
    editable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MelcoModelsDesignElement
     */
    is_required?: boolean;
    /**
     * 
     * @type {MelcoModelsDesignElementColor}
     * @memberof MelcoModelsDesignElement
     */
    color?: MelcoModelsDesignElementColor;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDesignElement
     */
    color_collection_id?: string | null;
    /**
     * 
     * @type {MelcoModelsColorCollection}
     * @memberof MelcoModelsDesignElement
     */
    color_collection?: MelcoModelsColorCollection;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDesignElement
     */
    default_color_id?: string | null;
    /**
     * 
     * @type {MelcoModelsDesignLetteringElement}
     * @memberof MelcoModelsDesignElement
     */
    lettering?: MelcoModelsDesignLetteringElement;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDesignElement
     */
    active_color_group_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDesignElement
     */
    lettering_id?: string | null;
}

export function MelcoModelsDesignElementFromJSON(json: any): MelcoModelsDesignElement {
    return MelcoModelsDesignElementFromJSONTyped(json, false);
}

export function MelcoModelsDesignElementFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsDesignElement {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'editable': !exists(json, 'editable') ? undefined : json['editable'],
        'is_required': !exists(json, 'is_required') ? undefined : json['is_required'],
        'color': !exists(json, 'color') ? undefined : MelcoModelsDesignElementColorFromJSON(json['color']),
        'color_collection_id': !exists(json, 'color_collection_id') ? undefined : json['color_collection_id'],
        'color_collection': !exists(json, 'color_collection') ? undefined : MelcoModelsColorCollectionFromJSON(json['color_collection']),
        'default_color_id': !exists(json, 'default_color_id') ? undefined : json['default_color_id'],
        'lettering': !exists(json, 'lettering') ? undefined : MelcoModelsDesignLetteringElementFromJSON(json['lettering']),
        'active_color_group_id': !exists(json, 'active_color_group_id') ? undefined : json['active_color_group_id'],
        'lettering_id': !exists(json, 'lettering_id') ? undefined : json['lettering_id'],
    };
}

export function MelcoModelsDesignElementToJSON(value?: MelcoModelsDesignElement | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'type': value.type,
        'editable': value.editable,
        'is_required': value.is_required,
        'color': MelcoModelsDesignElementColorToJSON(value.color),
        'color_collection_id': value.color_collection_id,
        'color_collection': MelcoModelsColorCollectionToJSON(value.color_collection),
        'default_color_id': value.default_color_id,
        'lettering': MelcoModelsDesignLetteringElementToJSON(value.lettering),
        'active_color_group_id': value.active_color_group_id,
        'lettering_id': value.lettering_id,
    };
}


